import { render, staticRenderFns } from "./Spin.vue?vue&type=template&id=24d9f68f"
import script from "./Spin.vue?vue&type=script&lang=js"
export * from "./Spin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d9f68f')) {
      api.createRecord('24d9f68f', component.options)
    } else {
      api.reload('24d9f68f', component.options)
    }
    module.hot.accept("./Spin.vue?vue&type=template&id=24d9f68f", function () {
      api.rerender('24d9f68f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Spin/Spin.vue"
export default component.exports